<template>
    <div>
    <el-card style="height: 100vh;">
        <div class="nav-header">
            <div class="item active">
                门店绑定
            </div>
            <!-- <div class="item">
                团购配送
            </div> -->
            <!-- <a href="" target="_blank"></a> -->
        </div>
        <div class="line-block" style="display:flex">
            <h4>门店信息 </h4>
        </div>
        <div class="avatar-text">
            <img src="../../assets/images/defaultPlist.png" alt="">
            <div class="text">
                <div class="store">
                    <span style="color: rgba(0,0,0,0.85);">门店：</span>{{ merchantName }}({{ baseInfo.merchantCode }})
                </div>
                <div class="store store-address ">
                    <span style="color: rgba(0,0,0,0.85);">门店地址： </span>{{ baseInfo.address }}
                </div>  
                <div class="extra">
  <span style="margin-right:12px;"  @click="bindStore" v-if="showBindBut">绑定门店</span>
    <span @click="bindStore" v-if="refresh" style="margin-right:12px;" >重新授权</span>
      <div class="spanText">
<span v-if="!showBindBut" style="color: rgba(0,0,0,0.65);">门店id：{{ poiId }}</span>
    <span></span>
     <el-tooltip v-if="!showBindBut" class="item" effect="dark" :content="appAuthToken" placement="bottom">
      <span   v-if="!showBindBut" class="token" style="color: rgba(0,0,0,0.65);padding-top: 2px;" >授权token：{{ appAuthToken }}</span></el-tooltip>
    <span style="display:flex" v-if="!showBindBut">授权过期时间：{{accessTokenExpiresDt | dataFormat}}
        <span v-if="refresh" style="margin-left: 10px; width: 132px;color: #F56C6C;font-weight:600">已过期，请重新授权!</span>
    </span>
       <span  v-if="!showBindBut">刷新token：{{refreshToken}}</span>
  <span  v-if="!showBindBut">刷新过期时间：{{refreshTokenExpiresDt | dataFormat}}</span>
                   </div>
                </div>
            </div>
        </div>
    </el-card>
    <el-dialog
  title="门店ID"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  :before-close="handleClose"
  :visible.sync="storeIdDialog"
  width="30%">
  <el-form>
    <el-form-item label="门店ID:">
        <el-input style="width:200px" v-model="storeId" placeholder="请输入门店id"></el-input>
    </el-form-item>
  </el-form>
  <span slot="footer" class="dialog-footer">
    <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
    <el-button style="background:#f59a23;color:#fff"  @click="upDateBtn">确 定</el-button>
  </span>
</el-dialog>

    </div>
</template>

<script >

export default{
    data(){
        return{
            now:null,
            storeId:'',
            storeIdDialog:false,
            merchantName:'',
            merchantCode:'',
            baseInfo:[],
            appAuthToken:"",
            poiId:'',
            showBindBut:true,
            accessTokenExpiresDt:'',
            refreshTokenExpiresDt:'',
            refreshToken:''
        }
    },
    methods:{
        handleClose(){
            if(this.storeId=='' || this.storeId==null){
                return
            }
            this.storeIdDialog=false
        },
        upDateBtn(){
            let data={}
            data.merchantCode=localStorage.getItem('merchantCode')
            data.shopId=this.storeId
            this.$http.post('/eleAuthToken/update',data).then(res=>{
               if(res.data.code==200){
                this.queryOne()
               }else{
                this.$message.error(res.data.message)
               }
               this.storeIdDialog=false
            })
        },
        queryOne(){
      this.$http.post('eleAuthToken/queryOne',{merchantCode:this.merchantCode}).then(res=>{
                if(res.data.data!=null){
                    this.showBindBut=false
                    this.appAuthToken=res.data.data.accessToken
                    this.poiId=res.data.data.shopId
                    this.accessTokenExpiresDt=res.data.data.accessTokenExpiresDt
                    this.refreshTokenExpiresDt=res.data.data.refreshTokenExpiresDt
                    this.refreshToken=res.data.data.refreshToken
               if(res.data.data!=null && (res.data.data.shopId==null || res.data.data.shopId=='') ){
            this.storeIdDialog=true
          }
                }else{
                    this.showBindBut=true
                }
            })
        },
        getBaseInfo(){
            this.$http.post('/merchantBaseInfo/queryOne',{merchantCode:this.merchantCode}).then(res=>{
                this.baseInfo=res.data.data
            })
        },
        getUpdate(){
       this.$http.post('eleAuthToken/queryOne',{merchantCode:this.merchantCode}).then(res=>{
         if(res.data.data!=null){
          this.showBindBut=false
           this.appAuthToken=res.data.data.accessToken
            this.poiId=res.data.data.shopId
         this.accessTokenExpiresDt=res.data.data.accessTokenExpiresDt
         this.refreshTokenExpiresDt=res.data.data.refreshTokenExpiresDt
          this.refreshToken=res.data.data.refreshToken
          if(res.data.data!=null && (res.data.data.shopId==null || res.data.data.shopId=='') ){
            this.storeIdDialog=true
          }
                }else{
                    this.showBindBut=true
                }
            })
        },
        // 绑定
        bindStore(){
            this.$http.post('ele/getAuthUrl',{merchantCode:this.merchantCode,merchantName:this.merchantName}).then(res=>{
                if(res.data.code==200){
                    var link=document.createElement('a')
                    link.href=res.data.data
                    link.target='_blank'
                    // link.click()
                    window.open(res.data.data)
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
    },
    created(){
        this.now=Date.now()
        this.merchantName=localStorage.getItem('merchantName')
        this.merchantCode=localStorage.getItem('merchantCode')
        this.getBaseInfo()
        this.queryOne()
    },
   mounted(){
           document.addEventListener('visibilitychange',()=>{
        this.queryOne()
})
    },
    computed:{
        refresh(){
            if(this.now > this.accessTokenExpiresDt && this.accessTokenExpiresDt!=null && this.accessTokenExpiresDt!=''){
                return true
            }else{
                return false
            }
        }
    }
}
</script>

<style lang="less" scoped>
.nav-header{
    display: flex;
    margin-bottom: 17px;
    .item{
        width: 56px;
        height: 21px;
        padding: 12px 16px;
        margin-right: 32px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
    }
    .item.active{
       border-bottom: 2px solid #ffbd00;
       font-weight: 500;
       color: #000;
}
}
.line-block{
   
    h4{
        font-size: 14px;
    padding-left: 8px;
    margin-top: unset;
    margin-bottom: 14px;
    border-left: 4px solid rgb(255, 189, 0);
    text-align: left;
    color: rgb(34,34,34);
    font-weight: 500;


    }
}
.avatar-text{
    height: 100px;
    display: flex;
    img{
        height: 100px;
        width: 100px;
        display: block;
        margin-right: 14px;
    }
    .text{
        display: flex;
    flex-direction: column;
    text-align: left;
    width: 90%;
    font-size: 14px;
    height: 500px;
    .store{
        height: 22px;
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.65);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .store.store-address{
        margin-bottom: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .extra{
        display: flex;
        >span{
            color: rgba(255, 96, 0,1);
            cursor: pointer;
        }
        >span:hover{
            color: rgba(255,96,0,0.85);
        }
    }
    }
}
span.token{
    // margin-left: 12px;
    color: rgba(0,0,0,0.65);
    width: 500px;overflow: hidden;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.spanText{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    line-height: 26px;
    transform: translateY(-3px);
    width:90%;
    span{
        width: 45%;
        display: block;
        color: rgba(0,0,0,0.65);
    }
}
</style>